module.exports = __webpack_public_path__ + "img/OverseaMember56.30e96ef1.jpg";